import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe, TrendingUp, Target } from 'lucide-react';

const Projection = () => {
  const { t } = useLanguage();

  const highlights = [
    { icon: Globe, text: 'Proyección Internacional' },
    { icon: TrendingUp, text: 'Desarrollo en Brasil' },
    { icon: Target, text: 'Potencial Europeo' }
  ];

  return (
    <section id="projection" className="py-24 bg-gradient-to-b from-zinc-950 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2
            className="text-5xl md:text-6xl font-bold mb-4 tracking-wide"
            style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          >
            {t.projection.title}
          </h2>
          <div className="h-1 w-20 bg-red-600 mx-auto mb-8" />
        </div>

        <div className="max-w-4xl mx-auto">
          <p
            className="text-gray-300 text-lg sm:text-xl leading-relaxed text-center mb-12"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {t.projection.text}
          </p>

          <div className="grid md:grid-cols-3 gap-6">
            {highlights.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 text-center hover:border-red-600/50 transition-all duration-300 hover:transform hover:-translate-y-1"
                >
                  <div className="bg-red-600/10 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-4">
                    <Icon className="text-red-600" size={28} />
                  </div>
                  <p
                    className="text-white font-semibold"
                    style={{ fontFamily: 'Oswald, sans-serif' }}
                  >
                    {item.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projection;
